.container {
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 100%;
	overflow-y: hidden;
}

.main {
	flex: 1;
	display: flex;
	align-items: stretch;
	min-width: 0;
	overflow: hidden;
}

.roadmapContainer {
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;
}

.roadmapContainerTransposed {
	position: relative;
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;
}
